export const wrapperPadding = `padding: 0px 20px;`;


// WEBPACK FOOTER //
// ./src/styles/shared/properties.js